import React from 'react';

export default function Loading(){
    return(
        <div id="loader">
            <img src={require('../../assets/img/loading-icon.png')} alt="icon" className="loading-icon" />
        </div>
    )
}